'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');

var NavMenu = react.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, props = tslib.__rest(_a, ["children", "className"]);
    return (jsxRuntime.jsx("ul", tslib.__assign({ className: "list-unstyled m-0 p-0 ".concat(className), role: "menu" }, props, { ref: ref }, { children: children })));
});
NavMenu.displayName = 'NavMenu';
var NavMenu$1 = NavMenu;

exports.default = NavMenu$1;
//# sourceMappingURL=NavMenu.js.map
